// Vittorio Valeri — standard product actions + exact homepage hero video.
function initStandardActions() {
  if (!customElements.get('standard-add-to-cart')) {
    customElements.define(
      'standard-add-to-cart',
      class StandardAddToCart extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.addToCart);
        }

        addToCart(event) {
          event.preventDefault();

          const productForm =
            this.closest('form[action*="/cart/add"]') ??
            this.closest('product-form')?.querySelector('form[action*="/cart/add"]');
          const variantInput = productForm?.querySelector('input[name="id"]');
          const fallbackVariantId = this.getAttribute('data-variant-id');
          const variantId = variantInput?.value || fallbackVariantId;

          if (!variantId) return;

          this.setAttribute('aria-busy', 'true');
          this.setAttribute('disabled', 'disabled');

          const cartDrawer = document.querySelector('cart-drawer');
          const sections = cartDrawer
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : [];

          window.VVCart.request(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
              sections,
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'standard-add-to-cart',
                    productVariantId: variantId,
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                }
                return;
              }

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'standard-add-to-cart',
                  productVariantId: variantId,
                  cartData: response,
                });
              }

              if (cartDrawer) cartDrawer.renderContents(response);
            })
            .catch((error) => console.error(error))
            .finally(() => {
              this.removeAttribute('aria-busy');
              this.removeAttribute('disabled');
            });
        }
      },
    );
  }

  if (!customElements.get('standard-buy-now')) {
    customElements.define(
      'standard-buy-now',
      class StandardBuyNow extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.buyNow);
        }

        buyNow(event) {
          event.preventDefault();

          const productForm =
            this.closest('form[action*="/cart/add"]') ??
            this.closest('product-form')?.querySelector('form[action*="/cart/add"]');
          const variantInput = productForm?.querySelector('input[name="id"]');
          const fallbackVariantId = this.getAttribute('data-variant-id');
          const variantId = variantInput?.value || fallbackVariantId;

          if (!variantId) return;

          this.setAttribute('aria-busy', 'true');
          this.setAttribute('disabled', 'disabled');

          window.VVCart.request(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'standard-buy-now',
                    productVariantId: variantId,
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                }
                return;
              }

              window.location.href = '/checkout';
            })
            .catch((error) => {
              console.error(error);
              this.removeAttribute('aria-busy');
              this.removeAttribute('disabled');
            });
        }
      },
    );
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
} else {
  initStandardActions();
}

// Exact video injection for homepage section b_tLwNBi only.
(() => {
  const VV_SECTION_DOM_ID = 'shopify-section-b_tLwNBi';
  const VV_VIDEO_URL = 'https://d30u2acmzc14ol.cloudfront.net/outputs/video/6430ee35-60e3-4742-98e5-8e9b2f9a40e1/912d88c9-14d9-41a5-baa5-3ae0cb5e925b.mp4';

  function mountExactHeroVideo() {
    const section = document.getElementById(VV_SECTION_DOM_ID);
    if (!section) return false;

    const media = section.querySelector('.vv-hero__media');
    if (!media) return false;

    let video = media.querySelector('video[data-vv-exact-hero-video="true"]');

    if (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.play().catch(() => {});
      return true;
    }

    const images = Array.from(media.querySelectorAll('.vv-hero__image'));
    const desktopImage = media.querySelector('.vv-hero__image--desktop');

    video = document.createElement('video');
    video.dataset.vvExactHeroVideo = 'true';
    video.src = VV_VIDEO_URL;
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.disablePictureInPicture = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');

    const posterUrl = desktopImage?.currentSrc || desktopImage?.src;
    if (posterUrl) video.poster = posterUrl;

    Object.assign(video.style, {
      position: 'absolute',
      inset: '0',
      width: '100%',
      height: '100%',
      display: 'block',
      objectFit: 'cover',
      objectPosition: 'center',
      zIndex: '20',
      opacity: '1',
      visibility: 'visible',
      pointerEvents: 'none',
      background: 'transparent',
    });

    const revealVideo = () => {
      section.dataset.vvHeroVideoState = 'playing';
      images.forEach((image) => {
        image.style.opacity = '0';
        image.style.visibility = 'hidden';
      });
    };

    const restoreImage = () => {
      section.dataset.vvHeroVideoState = 'error';
      images.forEach((image) => {
        image.style.opacity = '';
        image.style.visibility = '';
      });
      video.remove();
    };

    video.addEventListener('loadeddata', revealVideo, { once: true });
    video.addEventListener('playing', revealVideo, { once: true });
    video.addEventListener('canplay', () => video.play().catch(() => {}));
    video.addEventListener('error', restoreImage, { once: true });

    media.appendChild(video);
    section.dataset.vvHeroVideoState = 'mounted';

    video.load();
    requestAnimationFrame(() => video.play().catch(() => {}));

    return true;
  }

  function retryMount() {
    mountExactHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', retryMount, { once: true });
  } else {
    retryMount();
  }

  window.addEventListener('load', retryMount, { once: true });
  window.addEventListener('pageshow', retryMount);
  document.addEventListener('shopify:section:load', retryMount);
  document.addEventListener('shopify:section:reorder', retryMount);

  document.addEventListener(
    'pointerdown',
    () => {
      const section = document.getElementById(VV_SECTION_DOM_ID);
      const video = section?.querySelector('video[data-vv-exact-hero-video="true"]');
      video?.play().catch(() => {});
    },
    { once: true, passive: true },
  );

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    const section = document.getElementById(VV_SECTION_DOM_ID);
    const video = section?.querySelector('video[data-vv-exact-hero-video="true"]');
    video?.play().catch(() => {});
  });

  window.setTimeout(retryMount, 100);
  window.setTimeout(retryMount, 500);
  window.setTimeout(retryMount, 1500);
})();

